import $ = require('jquery');
/**
 * Class for the draggable helper
 *
 */
    class DragHelper {
        /**
         * Helper element
         */
        protected element: JQuery;
        /**
         * Reference to the original element from which the helper was created
         */
        protected originalElement: JQuery;

        constructor() {
            this.element = null;
            this.originalElement = null;
        }

        /**
         * Method responsible for fabricating the helper element based on
         * the original element
         * @abstract
         */
        create(originalEl: JQuery|string|HTMLElement) {
            return $();
        }

        /**
         * Creates and sets the helper element
         */
        createHelper(originalEl: JQuery) {
            this.originalElement = originalEl;
            this.element = this.create(originalEl);
            return this.element;
        }

        /**
         * Shows feedback when the item can't be dropped
         * @abstract
         */
        disable() {
            // abstract
        }

        /**
         * Shows feedback when the item can be dropped
         * @abstract
         */
        enable() {
            // abstract
        }

        /**
         * Sets an error message when the item can't be dropped
         * @abstract
         */
        setError(error: string|boolean) {
            // abstract
        }

        /**
         * Updates the visual feedback of the helper whether
         * it can or not be dropped in the current location
         */
        updateInvitation(canDrop: boolean, errorMsg?: string) {
            if (canDrop) {
                this.enable();
                this.setError(null);
            } else {
                this.disable();
                this.setError(errorMsg);
            }
        }
    }

export = DragHelper;



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/common/js/dd/DragHelper.ts
 **/